import React from 'react'

import architectureBg from 'src/shared/assets/architecture-bg.jpg'
import { Logo } from 'src/shared/components/icons/logos/logo'
import { Button } from 'src/shared/components/ui/buttons/button'

const FallbackPage: React.FC = () => {
  return (
    <div className="grid min-h-screen lg:grid-cols-2">
      <div
        className="relative hidden flex-col bg-muted p-10 text-white lg:flex"
        style={{
          backgroundImage: `url(${architectureBg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className="relative z-20 flex items-center text-lg font-medium">
          <Logo className="h-36 w-auto text-white" />
        </div>
        <div className="relative z-20 mt-auto">
          <blockquote className="space-y-2">
            <p className="text-lg">
              &quot;This platform has revolutionized how I handle referrals, making it easier to connect with the right
              professionals and grow my network.&quot;
            </p>
            <footer className="text-sm">Sofia Davis</footer>
          </blockquote>
        </div>
        <div className="absolute inset-0 bg-black/50" />
      </div>

      <div className="flex min-h-screen flex-col p-8 lg:justify-center">
        <div className="mb-4 lg:hidden">
          <Logo className="mx-auto h-12 w-36 text-primary" />
        </div>

        <div className="mx-auto w-full max-w-[450px]">
          <div className="flex min-h-screen flex-col items-center justify-center p-6">
            <div className="w-full max-w-md space-y-8 text-center">
              <h2 className="text-3xl font-extrabold text-primary">Service Unavailable</h2>
              <p className="mt-4 text-sm text-muted">Sorry! Our servers are currently down. Please try again later.</p>
              <div className="mt-8 flex justify-center">
                <Button variant="default" onClick={() => window.location.reload()}>
                  Retry
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default FallbackPage
